<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Valentino's Love-Child</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="titlePage" id="tp01"><a id="page03"><h2 class="titlePageAuthor"><span class="bold"><span><em class="italic"><span>Lucy Monroe</span></em></span></span></h2><h2 class="titlePageTitle"><span class="bold"><span>VALENTINO’S LOVE-CHILD</span></span></h2><p class="image"><span><img alt="image" src="Images/logo.jpg"/></span></p></a></div>
<a id="page03">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// valentinoslovechild_tp01.vue?58e65f1a